// Cloudflare Web Analytics configuration
import { logger } from '@/lib/logger';

export const CLOUDFLARE_ANALYTICS_TOKEN = 'e063c414950e48869fff5c1cedd99b86';

// Check if we're running on localhost
const isLocalhost = (): boolean => {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'localhost' || 
         hostname === '127.0.0.1' || 
         hostname === '[::1]' ||
         hostname.startsWith('192.168.') ||
         hostname.startsWith('10.') ||
         hostname.endsWith('.local');
};

// Initialize Cloudflare Web Analytics
export const initCloudflareAnalytics = (token: string = CLOUDFLARE_ANALYTICS_TOKEN) => {
  if (typeof window === 'undefined' || !token) return;

  // Skip loading Cloudflare Analytics on localhost to avoid CORS errors
  if (isLocalhost()) {
    logger.debug('[Cloudflare Analytics] Skipped on localhost');
    return;
  }

  // Check if script already exists
  const existingScript = document.querySelector('script[data-cf-beacon]');
  if (existingScript) {
    return; // Script already loaded
  }

  // Create and inject the Cloudflare Web Analytics script
  const script = document.createElement('script');
  script.defer = true;
  script.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  script.setAttribute('data-cf-beacon', JSON.stringify({ token }));
  document.head.appendChild(script);
};

// Remove Cloudflare Web Analytics script
export const removeCloudflareAnalytics = () => {
  if (typeof window === 'undefined') return;

  // Find and remove the Cloudflare Analytics script
  const script = document.querySelector('script[data-cf-beacon]');
  if (script && script.parentNode) {
    script.parentNode.removeChild(script);
  }
};
